/**
 * File d'attente des tutoriels : un seul overlay driver.js à la fois.
 *
 * Le drain est différé pour laisser les candidats s'inscrire avant qu'on ne choisisse —
 * sinon le premier arrivé partirait et la priorité ne servirait à rien.
 */

type PendingTour = {
  priority: number;
  run: () => void;
};

const DRAIN_DELAY_MS = 150;

let running = false;
let pending: PendingTour[] = [];
let drainTimer: ReturnType<typeof setTimeout> | null = null;

/** Les tutoriels de page se taisent pendant le tour d'accueil. */
let pageToursPaused = false;

const scheduleDrain = () => {
  if (drainTimer !== null) return;
  drainTimer = setTimeout(drain, DRAIN_DELAY_MS);
};

const drain = () => {
  drainTimer = null;
  if (running || pending.length === 0) return;

  pending.sort((a, b) => b.priority - a.priority);
  const next = pending.shift();
  if (!next) return;

  running = true;
  next.run();
};

/**
 * Inscrit un tour dans la file. La fonction renvoyée annule la demande : un composant
 * démonté avant son tour ne doit pas se lancer sur une page qui n'est plus à l'écran.
 */
export const requestTour = (run: () => void, priority = 0): (() => void) => {
  const entry: PendingTour = { priority, run };
  pending.push(entry);
  scheduleDrain();
  return () => {
    pending = pending.filter((item) => item !== entry);
  };
};

export const releaseTour = () => {
  running = false;
  scheduleDrain();
};

export const pausePageTours = () => {
  pageToursPaused = true;
};

export const resumePageTours = () => {
  pageToursPaused = false;
};

export const arePageToursPaused = () => pageToursPaused;
